<template>
  <session class="page-protocol">
		<!-- <div class="protocol-header">
			<div class="title-wrap">
				<span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ title }}</span>
				<span class="date" :class="{ ffen: getLocalLangCode() != 'zh' }">{{date}}</span>
			</div>
			<img class="logo" src="@/assets/images/logo-en.svg" v-if="!getLocalLangCode() || getLocalLangCode() == 'en'" />
      <img class="logo" src="@/assets/images/logo.svg" v-if="getLocalLangCode() == 'zh'" />
      <img class="logo" src="@/assets/images/logo-jp.svg" v-if="getLocalLangCode() == 'jp'" />
      <img class="logo" src="@/assets/images/logo-kr.svg" v-if="getLocalLangCode() == 'kr'" />
		</div> -->
		<div class="protocol-back" @click="Utils.toTargetPage('/')">
			<Icon name="back" /><span>{{LOCAL('backtohome')}}</span>
		</div>
    <div class="protocol-body" id="protocol-body" v-html="Utils.presetHtmlText(content)" />
  </session>
</template>

<script setup>
  import { onMounted, ref, watch } from 'vue';
	import { LOCAL, getLocalLangCode } from '@/assets/lang';
	import Icon from '@/components/icon/index.vue';
  import { useRouter, useRoute } from 'vue-router';
	import router from '@/router';
  const route = useRoute();

  import * as Utils from '@/assets/utils.js';

  import * as termContent from '@/assets/lang/term.js';
  import * as privateContent from '@/assets/lang/private.js';

  const title = ref('');
  const content = ref('');
	const date = ref(``);

	const getContent = async () => {
		const { target } = route.params;
		console.log('target', target)

		const langCode = getLocalLangCode()

		// 设置页面标题
		let titleContent = ({
			private: privateContent.title,
			term: termContent.title
		})[target] || {};
		title.value = titleContent[langCode];
		document.title = title.value;

		// 日期
		let dateContent = ({
			private: privateContent.date,
			term: termContent.date
		})[target] || {};
		date.value = dateContent[langCode];

		// 设置页面内容
		let textContent = ({
			private: privateContent.content,
			term: termContent.content,
		})[target] || {};
		console.log('textContent----', textContent)
    content.value = textContent[langCode]

	};
  onMounted(() => {
    getContent();
  });
	watch(() => route.params, () => {
		window.location.reload()
	}, { deep: true });

	const backHandle = () => {
		router.go(-1);
	}

</script>

<style scoped lang="less">
@import "index.less";
</style>
